export default __webpack_public_path__ + "static/media/pay respects 8.85549c50.png";